import React, { Component } from 'react';
import { slide as Menu } from 'react-burger-menu';
import { NavLink } from 'react-router-dom';
import $ from 'jquery';

import { eventTypes, trackEvent } from '../../helpers/AnalyticsManager';
import MenuIcon from '../../images/menu-icon.png';
import { applyForm } from '../../common/Links';

import './SideMenu.css';

class SideMenu extends Component {
  constructor() {
    super();

    this.state = {
      menuOpen: false,
    };

    this.handleScroll = this.handleScroll.bind(this);
  }

  componentWillMount() {
    // When this component mounts, begin listening for scroll changes
    window.addEventListener('scroll', this.handleScroll);
  }

  componentDidMount() {
    // .bm-menu component came with inline styling setting the height to 100%
    // removing the height rule we can let the sidebar grow beyond the navbar
    $('.bm-menu').attr('style', (i, style) => style && style.replace(/height[^;]+;?/g, ''));
  }

  componentWillUnmount() {
    // If this component is unmounted, stop listening
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    this.closeMenu();
  }

  handleMenuStateChange(state) {
    this.setState({ menuOpen: state.isOpen });
  }

  handleActiveOptionClick(e) {
    const parent = e.target.parentElement;
    const isActive = parent.classList.contains('active');

    if (isActive) {
      this.closeMenu();
    }
  }

  closeMenu() {
    this.setState({ menuOpen: false });
  }

  render() {
    const { menuOpen } = this.state;
    return (
      <Menu
        isOpen={menuOpen}
        onStateChange={state => this.handleMenuStateChange(state)}
        right
        customBurgerIcon={<img src={MenuIcon} alt="burger menu" />}
        customCrossIcon={<h1>X</h1>}
        // noOverlay
      >
        <NavLink onClick={e => this.handleActiveOptionClick(e)} to="/" exact className="menu-item">
          <span>HOME</span>
        </NavLink>
        <NavLink onClick={e => this.handleActiveOptionClick(e)} to="/english/about" className="menu-item">
          <span>ABOUT</span>
        </NavLink>
        <NavLink onClick={e => this.handleActiveOptionClick(e)} to="/english/portfolio" className="menu-item">
          <span>PORTFOLIO</span>
        </NavLink>
        <NavLink onClick={e => this.handleActiveOptionClick(e)} to="/english/publications" className="menu-item">
          <span>PUBLICATIONS</span>
        </NavLink>
        <NavLink onClick={e => this.handleActiveOptionClick(e)} to="/english/industry" className="menu-item">
          <span>MARKET</span>
        </NavLink>
        <NavLink
          to="/english/contact"
          className="menu-item-small"
          onClick={(e) => {
            trackEvent(eventTypes.menuContact);
            this.handleActiveOptionClick(e);
            return true;
          }}
        >
          <span>CONTACT</span>
        </NavLink>
        <a
          className="menu-item-small"
          href={applyForm}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            trackEvent(eventTypes.menuApply);
            return true;
          }}
        >
          <span>APPLY</span>
        </a>
      </Menu>
    );
  }
}

export default SideMenu;
